import {
    Breakpoint,
    WIDTH_BREAKPOINTS,
    useMediaQuery,
    HEIGHT_BREAKPOINTS,
} from './media-query-helpers';

export const useMinWidthMediaQueries = (breakpoint: Breakpoint): boolean => {
    return useMediaQuery(`(min-width: ${WIDTH_BREAKPOINTS[breakpoint]}px)`);
};

export const useMinHeightMediaQueries = (breakpoint: Breakpoint): boolean => {
    return useMediaQuery(`(min-height: ${HEIGHT_BREAKPOINTS[breakpoint]}px)`);
};
